import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const enFiles = import.meta.glob("./locales/en/*.json", { eager: true });
const ukFiles = import.meta.glob("./locales/uk/*.json", { eager: true });
const ruFiles = import.meta.glob("./locales/ru/*.json", { eager: true });

const buildResources = (files: Record<string, any>) => {
  const namespaces: Record<string, any> = {};

  for (const key in files) {
    const fileName = key.split("/").pop() || key;
    const ns = fileName.replace(".json", "");

    namespaces[ns] = files[key].default || files[key];
  }

  return namespaces;
};

const en = buildResources(enFiles);
const uk = buildResources(ukFiles);
const ru = buildResources(ruFiles);

console.log("✅ Loaded namespaces (EN):", Object.keys(en));

const savedLanguage = localStorage.getItem("i18nextLng") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: en,
    uk: uk,
    ru: ru,
  },
  lng: savedLanguage,
  fallbackLng: "en",
  ns: Object.keys(en),
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("i18nextLng", lng);
});

export default i18n;
